import React, { useEffect } from 'react';
import FormularioLogin from '../components/FormularioLogin/FormularioLogin';
import { useAuth } from '../context/AuthContext';
import Carregamento from '../components/Carregamento/Carregamento';
import { APP_ROUTES } from '../services/app_routes';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const navigate = useNavigate();
    const { login, user, carregando } = useAuth();

    useEffect(() => {
        if (user) {
            navigate(APP_ROUTES.HOME, { replace: true });
        }
    }, [user, navigate]);

    const handleLogin = async (email, senha) => {
      await login(email, senha);
    }

    return (
      <div className={"container-princial"}>
        {carregando && <Carregamento/>}
        <FormularioLogin aoLogar={handleLogin} />
      </div>
    );
}
 
export default Login;